'use strict';
define([
    '../../../../lib/domQ',
    './cookieService',
    '../navigation/Breakpoint',
    '../util',
    '../../data/config/app',
    'xhr-promise',
    '../analytics'
], function (domQ, mnsCookieService, breakpoint, utils, config, XhrPromise, analytics) {

    function HeaderLinks(el) {
        if (el) {
            this.nav = el.querySelector('nav');
            this.headerEl = document.getElementById('common-hdr-main');
            this.signIn = el.querySelector('.navigation-res-nav-header__item--login');
            this.signUp = el.querySelector('.navigation-res-nav-header__item--register');
            this.signInLink = el.querySelector('.navigation-res-nav-header__login-link');
            this.signInLoginLink = el.querySelector('.navigation-signin-login-link');
            this.myAccount = el.querySelector('.navigation-res-nav-header__item--myaccount');
            this.welcomeMessage = el.querySelector('.navigation-header__welcome');
            this.atwelcomediv = document.querySelector('.dashboardwelcometext');
            this.tabletCheckout = el.querySelector('.navigation-res-nav-header__item--checkout');
            this.viewBagCount = el.querySelector('.navigation-nav-header__bag-count');
            this.help = el.querySelector('.help');
            this.signoutIcon = el.querySelector('.navigation-primary__menu-icon__account.navigation-icon-signout');
            this.countrySelectorDesktop = el.querySelector('.navigation-res-nav-header__icon--country');
            this.countrySelectorMobile = document.querySelector('.navigation-mobile-country-header');
            this.finalLinkMobile = document.querySelector('.navigation-country-mobile--link');
            this.countryDomMobile = document.querySelector('.navigation-country-mobile--country-list');
            this.languageDomMobile = document.querySelector('.navigation-country-mobile--language-list');
            this.countryDom = el.querySelector('.navigation-country-overlay--country-list');
            this.languageDom = el.querySelector('.navigation-country-overlay--language-list');
            this.finalLink = el.querySelector('.navigation-country-overlay--link');
            this.storeLocatorIcon = el.querySelector('.navigation-res-nav-header__icon--location');
            this.storeLocatorItem = el.querySelector('.navigation-res-nav-header__item--location');
            this.logo = el.querySelector('.navigation-logo');
            this.headerSearchTypeDirect = el.querySelector('.navigation-search-bar--submit');
            this.headerNewcollapsedSearch = el.querySelector('.navigation-search_analytics');
            this.headerNewExposedSearch = el.querySelector('.navigation-exposed_search_analytics');
            this.bottomSparksLink = document.querySelector('.navigation-pane-one-navbottom .navigation-sparks-analytics a');
            this.bottomSparksLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-sparks-analytics a');
            this.bottomMyAccountLink = document.querySelector('.navigation-pane-one-navbottom .navigation-myaccount-analytics a');
            this.bottomMyAccountPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-myaccount-analytics a');
            this.bottomHelpLink = document.querySelector('.navigation-pane-one-navbottom .navigation-bottom-help-analytics');
            this.bottomHelpLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-bottom-help-analytics');
            this.bottomContactUs = document.querySelector('.navigation-pane-one-navbottom .navigation-bottom-contactus');
            this.bottomContactUsPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-bottom-contactus');
            this.bottomSignOutLink = document.querySelector('.navigation-pane-one-navbottom .navigation-signout-register a');
            this.bottomSignOutLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-signout-register a');
            this.bottomRegisterLink = document.querySelector('.navigation-pane-one-navbottom .navigation-register-analytics a');
            this.bottomRegisterLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-register-analytics a');
            this.bottomFindaStoreLink = document.querySelector('.navigation-pane-one-navbottom .navigation-find-store-analytics a');
            this.bottomFindaStoreLinkPaneTwo = document.querySelector('.navigation-pane-two-navbottom .navigation-find-store-analytics a');
            this.hamburgerEl = document.querySelector('.navigation-res-nav-header__item--menu');
            this.backBarLink = document.querySelector('.navigation-submenu__back-bar-link');
        }
    }
    HeaderLinks.prototype = {
        /**
         * Show header navigation
         */
        show: function () {
            this.toggleLoginLink();
            this.toggleCheckoutLink();
            this.updateViewBagCount();
            this.redirectSignInLink();
            domQ(this.nav).removeClass('navigation-top-links--hidden');
            this.bindHeaderLinkEvents();
            if (this.getUserSegmentSearchSwitch() && mnsCookieService.isUserLoggedIn() && !mnsCookieService.getUserSegmentCookieValue()) {
                this.loadUserSegment();
            }
        },

        /**
         * user segment feature switch
         */
        getUserSegmentSearchSwitch: function () {
            if (typeof window.userSegmentSearchEnabled !== 'undefined') {
                return window.userSegmentSearchEnabled;
            }
        },

        /**
         * user segment cookie gets dropped if user is logged in
         */
        loadUserSegment: function () {
            var localStorage = window.localStorage;
            var xhrp = new XhrPromise();
            return xhrp.send({
                url: config.wcsBaseUrl + '/MSUserSegment?storeId=' + config.storeId + '&catalogId=' + config.catalogId,
                method: 'GET'
            }).then(function (response) {
                if (response.status === 200) {
                    localStorage.setItem('userSegmentSearch', response.responseText.userSegmentSearch);
                }
            }).catch(function () {
                //Handle errors here
            });
        },

        /**
         * toggle header sign-in, register and my account links
         */
        toggleLoginLink: function () {
            var welcomeMsg;

            if (mnsCookieService.isUserLoggedIn()) {

                // toggle my account links
                domQ(this.myAccount).removeClass('navigation-res-nav-header__item--hidden');
                domQ(this.welcomeMessage).removeClass('navigation-res-nav-header__item--hidden');
                // set welcome message
                welcomeMsg = mnsCookieService.getUsername();
                domQ(this.welcomeMessage).text(welcomeMsg);
            } else {
                // toggle signin / register links
                domQ(this.signIn).removeClass('navigation-res-nav-header__item--hidden');
            }
        },

        /**
         * toggle tablet checkout links
         */
        toggleCheckoutLink: function () {
            if (breakpoint.size() === 'small' && mnsCookieService.getBasketSizeCookieValue() > 0) {
                domQ(this.tabletCheckout).removeClass('navigation-res-nav-header__item--hidden');
            }
        },

        /**
         * Updates view count DOM content based on basket size cookie
         */
        updateViewBagCount: function () {
            var bagCount = mnsCookieService.getBasketSizeCookieValue();
            domQ(this.viewBagCount).text(bagCount);
        },

        /**
         * Bind click event to sign in link to redirect to target
         * url appended with source url
         */
        redirectSignInLink: function () {
            this.signInLink.addEventListener('click', this.redirectSignInLinkSetup);
            this.signInLoginLink.addEventListener('click', this.redirectSignInLinkSetup);
        },

        redirectSignInLinkSetup: function (e) {
            e.preventDefault();
            window.location.href = utils.appendSourceUrl(this.getAttribute('href'), window.location.href);
        },
        /**
         * Bind header links analytics events
         */
        bindHeaderLinkEvents: function () {
            window.analyticsNavCountryLanguage = 'English';
            window.analyticsNavCountryName = (config.storeId === '10451') ? 'IE' : 'GB';
            // Bind click event to M&S logo link on header
            analytics.bind(this.logo, [{
                functionName: 'analyticsHeaderLinkTracking',
                event: 'click',
                data: 'header: logo'
            }]);
            // Bind 'click' event to 'HELP' link on header
            analytics.bind(this.help, [{
                functionName: 'analyticsHeaderLinkTracking',
                event: 'click',
                data: 'header: help'
            }]);
            // Bind 'click' event to 'REGISTER' link on header
            if (this.signUp) {
                analytics.bind(this.signUp, [{
                    functionName: 'analyticsHeaderLinkTracking',
                    event: 'click',
                    data: 'header: register'
                }]);
            }
            // Bind 'click' event in country selection dropdown links in header
            if (this.countrySelectorDesktop) {
                analytics.bind(this.countrySelectorDesktop, [{
                    functionName: 'analyticsYourCountrySelectionNav',
                    event: 'click'
                }]);
            }
            if (this.countrySelectorMobile) {
                analytics.bind(this.countrySelectorMobile, [{
                    functionName: 'analyticsYourCountrySelectionNav',
                    event: 'click'
                }]);
            }
            // Bind 'change' event in country selection dropdown links in header
            analytics.bind(this.countryDomMobile, [{
                functionName: 'analyticsYourCountryChange',
                event: 'change'
            }]);
            analytics.bind(this.languageDomMobile, [{
                functionName: 'analyticsYourCountryLanguageChange',
                event: 'change'
            }]);
            analytics.bind(this.countryDom, [{
                functionName: 'analyticsYourCountryChangeDesktop',
                event: 'change'
            }]);
            analytics.bind(this.languageDom, [{
                functionName: 'analyticsYourCountryLanguageChangeDesktop',
                event: 'change'
            }]);
            analytics.bind(this.finalLinkMobile, [{
                functionName: 'analyticsYourCountrySumbit',
                event: 'click'
            }]);
            analytics.bind(this.finalLink, [{
                functionName: 'analyticsYourCountrySumbit',
                event: 'click'
            }]);
            // Bind 'click' event in store locator icon
            analytics.bind(this.storeLocatorIcon, [{
                functionName: 'analyticsHeaderLinkTracking',
                event: 'click',
                data: 'header: store locater'
            }]);
            // Bind 'click' event in store locator item
            analytics.bind(this.storeLocatorItem, [{
                functionName: 'analyticsHeaderLinkTracking',
                event: 'click',
                data: 'header: store locater'
            }]);
            // Bind 'click' event in search button in header
            analytics.bind(this.headerSearchTypeDirect, [{
                functionName: 'analyticsHeaderSearchTypeDirect',
                event: 'click'
            }]);
            // Bind 'click' event in burger menu button in header
            if (this.hamburgerEl) {
                analytics.bind(this.hamburgerEl, [{
                    functionName: 'analyticsOpenBurgerMenu',
                    event: 'click'
                }]);
            }
            if (this.backBarLink) {
                analytics.bind(this.backBarLink, [{
                    functionName: 'analyticsBackToDepartment',
                    event: 'click'
                }]);
            }
            // Bind 'click' event in collapsed search icon in header for analytics
            if (this.headerNewcollapsedSearch) {
                analytics.bind(this.headerNewcollapsedSearch, [{
                    functionName: 'analyticsheaderNewsearch',
                    event: 'click'
                }]);
            }
            // Bind 'click' event in exposed search icon in header for analytics
            if (this.headerNewExposedSearch) {
                analytics.bind(this.headerNewExposedSearch, [{
                    functionName: 'analyticsheaderNewsearch',
                    event: 'click'
                }]);
            }
            // Bind 'click' event in Sparks link in mobile pane1
            if (this.bottomSparksLink) {
                this.bottomSparksLink.addEventListener('click', this.analyticsBottomsparksLink);
            }
            // Bind 'click' event in Sparks link in mobile pane2
            if (this.bottomSparksLinkPaneTwo) {
                this.bottomSparksLinkPaneTwo.addEventListener('click', this.analyticsBottomsparksLink);
            }
            // Bind 'click' event in myAccount pane1
            if (this.bottomMyAccountLink) {
                this.bottomMyAccountLink.addEventListener('click', this.analyticsBottomMyAccountLink);
            }
            // Bind 'click' event in myAccount pane2
            if (this.bottomMyAccountPaneTwo) {
                this.bottomMyAccountPaneTwo.addEventListener('click', this.analyticsBottomMyAccountLink);
            }
            // Bind 'click' event in help link pane1
            if (this.bottomHelpLink) {
                this.bottomHelpLink.addEventListener('click', this.analyticsbottomHelpLink);
            }
            // Bind 'click' event in help link pane2
            if (this.bottomHelpLinkPaneTwo) {
                this.bottomHelpLinkPaneTwo.addEventListener('click', this.analyticsbottomHelpLink);
            }
            // Bind 'click' event in contactUs link pane1
            if (this.bottomContactUs) {
                this.bottomContactUs.addEventListener('click', this.analyticsbottomContactUsLink);
            }
            // Bind 'click' event in contactUs link pane2
            if (this.bottomContactUsPaneTwo) {
                this.bottomContactUsPaneTwo.addEventListener('click', this.analyticsbottomContactUsLink);
            }
            // Bind 'click' event in signOut link pane1
            if (this.bottomSignOutLink) {
                this.bottomSignOutLink.addEventListener('click', this.analyticsbottomSignOutLink);
            }
            // Bind 'click' event in signOut link pane2
            if (this.bottomSignOutLinkPaneTwo) {
                this.bottomSignOutLinkPaneTwo.addEventListener('click', this.analyticsbottomSignOutLink);
            }
            if (this.signoutIcon) {
                this.signoutIcon.parentElement.addEventListener('click', this.analyticsbottomSignOutLink);
            }
            // Bind 'click' event in Register link pane1
            if (this.bottomRegisterLink) {
                this.bottomRegisterLink.addEventListener('click', this.analyticsbottomRegisterLink);
            }
            // Bind 'click' event in Register link pane2
            if (this.bottomRegisterLinkPaneTwo) {
                this.bottomRegisterLinkPaneTwo.addEventListener('click', this.analyticsbottomRegisterLink);
            }
            // Bind 'click' event in Find A Store  link in mobile pane1
            if (this.bottomFindaStoreLink) {
                this.bottomFindaStoreLink.addEventListener('click', this.analyticsBottomFindaStoreLink);
            }
            // Bind 'click' event in Find A Store  link in mobile pane2
            if (this.bottomFindaStoreLinkPaneTwo) {
                this.bottomFindaStoreLinkPaneTwo.addEventListener('click', this.analyticsBottomFindaStoreLink);
            }
        },

        //Tracks the click of Sparks button from header on mobile nav
        analyticsBottomsparksLink: function (evt) {
            var element = evt.target;
            var newhref = element.dataset.href;
            if (element) {
                // strip out existing intid query or hash parameter
                if (element.dataset.href.indexOf('intid') > -1) {
                    newhref = element.dataset.href.split('?intid')[0].split('&intid')[0].split('#intid')[0];
                    if (element.dataset.href.split('intid')[1].indexOf('&') > -1) {
                        newhref = newhref + (newhref.indexOf('?') === -1 ? '?' : '&') + element.dataset.href.split('intid')[1].split('&').splice(1).join('&');
                    }
                } else {
                    newhref = element.dataset.href;
                }
                // append #intid tracking code
                element.href = newhref + '#intid=gnav_mob_sparks_sticky';
            }
        },

        //Tracks the click of help button from header on mobile nav
        analyticsbottomHelpLink: function (evt) {
            let element = evt.target;
            if (element) {
                element.href = element.dataset.href + '?intid=gnav_mob_help_sticky';
            }
        },

        //Tracks the click of Contact Us button from header on mobile nav
        analyticsbottomContactUsLink: function (evt) {
            let element = evt.target;
            if (element) {
                element.href = element.dataset.href + '?intid=gnav_mob_contact-us_sticky';
            }
        },

        //Tracks the click of Sign Out button from header on mobile nav
        analyticsbottomSignOutLink: function () {
            window.sessionStorage.setItem('aa_account_action', 'myaccount:sign out');
        },

        //Tracks the click of Register button from header on mobile nav
        analyticsbottomRegisterLink: function (evt) {
            let element = evt.target;
            if (element) {
                element.href = element.dataset.href + '&intid=gnav_mob_register_sticky';
            }
        },
        //Tracks the click of Find A Store button from header on mobile nav
        analyticsBottomFindaStoreLink: function (evt) {
            let element = evt.target;
            if (element) {
                if (element.href.indexOf('&intid') === -1) {
                    element.href = element.href + '&intid=gnav_mob_find-a-store_sticky';
                } else if (element.href.split('&intid')[0] !== null) {
                    element.href = element.href.split('&intid')[0] + '&intid=gnav_mob_find-a-store_sticky';
                }
            }
        }


    };

    return HeaderLinks;
});




// WEBPACK FOOTER //
// ./src/mns-core-ui-header/templates/header/js/links/Index.js